module.exports = __webpack_public_path__ + "media/images/sandbox/sailormoon--thumb-712041e41868fe3dc69c4b1f0ebce31f.png";